import { keyframes, styled, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

const tipInFromAbove = keyframes`
  from { opacity: 0; transform: translateY(-0.3125rem) scale(.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

const tipInFromBelow = keyframes`
  from { opacity: 0; transform: translateY(0.3125rem) scale(.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

const ARROW_OFFSET = '-0.25rem';

export const getCuePopperSx = (theme: Theme): SystemStyleObject<Theme> => ({
  zIndex: theme.zIndex.tooltip,
  pointerEvents: 'none',
});

export const CueBubble = styled('div', { name: 'CueBubble' })(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '0.4375rem',
  whiteSpace: 'nowrap',
  // these two flip together across themes, so no branching on the mode
  backgroundColor: theme.palette.custom.OV.sys.tertiary,
  color: theme.palette.custom.OV.sys.surfaceContainerLowest,
  fontSize: '0.75rem',
  fontWeight: 600,
  letterSpacing: '0.01em',
  padding: '0.5rem 0.875rem',
  borderRadius: '999px',
  boxShadow: theme.shadows[8],
  pointerEvents: 'none',
  animation: `${tipInFromAbove} .28s cubic-bezier(.2, .8, .2, 1)`,

  '&::before': {
    content: '""',
    position: 'absolute',
    top: ARROW_OFFSET,
    left: '50%',
    width: '0.5625rem',
    height: '0.5625rem',
    transform: 'translateX(-50%) rotate(45deg)',
    backgroundColor: theme.palette.custom.OV.sys.tertiary,
    borderRadius: '0.125rem',
  },

  // Popper stamps the resolved side on its root, flips included
  '[data-popper-placement^="top"] > &': {
    animationName: tipInFromBelow,
  },
  '[data-popper-placement^="top"] > &::before': {
    top: 'auto',
    bottom: ARROW_OFFSET,
  },

  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
}));
